import {API_URL_LOCALE_BASE} from '../configuration/config';
import axios from 'axios';

export const getDataGrafico = async (idTipoGrafico: number) => {
    try {
        let response = await axios.post(API_URL_LOCALE_BASE + 'get-data-graph', {'id_tipo_grafico': idTipoGrafico});
        return response;
    } catch (error) {
        return { ok: false, error }
    }
}

export const getFuenteGrafico:any = async () => {
    try {
        let response = await axios.post(API_URL_LOCALE_BASE + 'get-fuente-data', {});
        return response;
    } catch (error) {
        return { ok: false, error }
    }
}
export const getAllFuenteGrafico:any = async () => {
    try {
        let response = await axios.post(API_URL_LOCALE_BASE + 'get-listado-fuentes', {});
        return response;
    } catch (error) {
        return { ok: false, error }
    }
}
export const getEmpresasFuente = async (idFuente: number) => {
    try {
        let response = await axios.post(API_URL_LOCALE_BASE + 'getEmpresas', {'id_tipo_fuente': idFuente});
        return response;
    } catch (error) {
        return { ok: false, error }
    }
}
export const getEcenariosFuente = async (idFuente: any,nombreFuente:string) => {
    try {
        let response = await axios.post(API_URL_LOCALE_BASE + 'getEcenarios', {
            "idTipoGrafico":idFuente,
            "idEmpresa":nombreFuente
        });
        return response;
    } catch (error) {
        return { ok: false, error }
    }
}
export const getGraficoDataEspontanea = async () => {
    try {
        
        let response = await axios.post(API_URL_LOCALE_BASE + 'get-data-grafico-espontanea', {

        },{
            timeout:3000000
        });
        return response;
    } catch (error) {
        return { ok: false, error }
    }
}


export const getGraficoPagina = async (idFuente: any,nombreEmpresa:string,nombreEscenario:string) => {
    try {
        let response = await axios.post(API_URL_LOCALE_BASE + 'getDataGraficoPagina', {
            "idTipoGrafico":idFuente,
            "idEmpresa":nombreEmpresa,
            "escenario":nombreEscenario

        });
        return response;
    } catch (error) {
        return { ok: false, error }
    }
}

export const getSemanasPersonajes = async () => {
    try {
        let response = await axios.post(API_URL_LOCALE_BASE + 'obtenerSemanas', {


        });
        return response;
    } catch (error) {
        return { ok: false, error }
    }
}


export const getRankingSemana = async () => {
    try {
        let response = await axios.post(API_URL_LOCALE_BASE + 'obtenerRankingSemana', {


        });
        return response;
    } catch (error) {
        return { ok: false, error }
    }
}

export const getGraficoSemana = async (id: any) => {
    try {
        let response = await axios.post(API_URL_LOCALE_BASE + 'graphPersonajeSemana', {
            id_semana:id


        });
        return response;
    } catch (error) {
        return { ok: false, error }
    }
}

export const getGraficoRankingSemana = async (id: any) => {
    try {
        let response = await axios.post(API_URL_LOCALE_BASE + 'graphRankingSemana', {
            id_semana:id


        });
        return response;
    } catch (error) {
        return { ok: false, error }
    }
}

export const getEmpresasGraficoSegundaVuelta = async () => {
    try {
        let response = await axios.post(API_URL_LOCALE_BASE + 'grafico-presidencial-2da-vuelta-empresas', {
        

        });
        return response;
    } catch (error) {
        return { ok: false, error }
    }
}
export const getEcenariosGraficoSegundaVuelta = async (empresa: any) => {
    console.log(empresa);
    
    try {
        let response = await axios.post(API_URL_LOCALE_BASE + 'grafico-presidencial-2da-vuelta-escenarios', {
            empresa:empresa


        });
        return response;
    } catch (error) {
        return { ok: false, error }
    }
}

export const getGrafico = async (empresa: any,escenario:any) => {
    console.log('getGrafico',empresa);
    
    try {
        let response = await axios.post(API_URL_LOCALE_BASE + 'grafico-segunda-2da-vuelta', {
            empresa:empresa,
            escenario:escenario


        });
        return response;
    } catch (error) {
        return { ok: false, error }
    }
}

export const getCategoriaPrioridadesCiudadanas = async (id_categoria: number) => {
    
    try {
        let response = await axios.post(API_URL_LOCALE_BASE + 'categoria_prioridades_ciudadanas', {
            id_categoria:id_categoria
        });
        return response;
    } catch (error) {
        return { ok: false, error }
    }
}

export const getListGraficoFiltro = async () => {
    
    try {
        let response = await axios.post(API_URL_LOCALE_BASE + 'list-graficos-filtro', {
        });
        return response;
    } catch (error) {
        return { ok: false, error }
    }
}
